import { useState, useEffect, Suspense } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, json, Form } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/PassageList.module.scss'
import LoadingSpinner from './components/LoadingSpinner'
import { getPassageList, uploadRequestDoc, deletePassage } from '../util/p_api'
import '../../node_modules/leaflet-draw/dist/leaflet.draw.css'
import { useAuth } from '../contexts/AuthContext'
import Download from './download'
import { toast } from 'react-hot-toast'

export default function PassageList({ title }) {
  Title(title)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState()
  const [user, setUser] = useState(null)
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const statusInterpreter = ['ثبت شده', 'ارجاع به بنیاد شهید و امور ایثارگران', 'ارجاع به ناظر', 'ارسال به کمیسیون', 'تایید شده', 'رد شده', 'در دست اقدام']

  const handleUpdate = async (e, id, field) => {
    try {
      const res = await uploadRequestDoc(e.target.files[0], id, field)
      console.log(res)
      if (res.result) {
        alert('درخواست با موفقیت ارسال گردید')
        window.location.reload()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const determineStatus = (status) => {
    let result

    switch (status) {
      case '0':
      case 0:
        result = <span className="badge badge-light">{statusInterpreter[0]}</span>
        break
      case '1':
      case 1:
        result = (
          <span className="badge" style={{ background: 'linear-gradient(100.26deg, #38EC3A 0.72%, #FD0017 98.42%)', color: '#fff' }}>
            {statusInterpreter[1]}
          </span>
        )
        break
      case '2':
      case 2:
        result = <span className="badge badge-primary">{statusInterpreter[2]}</span>
        break
      case '3':
      case 3:
        result = <span className="badge badge-warning animated animate__animated animate__heartBeat animate__delay-2s animate__infinite ">{statusInterpreter[3]}</span>
        break
      case '4':
      case 4:
        result = (
          <span className="badge badge-success" style={{ transform: 'rotate(-14deg) scale(1.4)' }}>
            {statusInterpreter[4]}
          </span>
        )
        break
      case '5':
      case 5:
        result = (
          <span className="badge badge-danger" style={{ transform: 'rotate(-14deg) scale(1.4)' }}>
            {statusInterpreter[5]}
          </span>
        )
        break
      case '6':
      case 6:
        result = <span className="badge badge-dark">{statusInterpreter[6]}</span>
        break
      default:
        result = <span className="badge badge-primary">تعریف نشده</span>
        break
    }

    return result
  }

  const handleDelete = (id) => {
    if (window.confirm('از حذف این صورتجلسه مطمئن هستید؟')) {
      deletePassage(id).then((res) => {
        toast('درخواست شما با موفقیت پاک شد')

        getPassageList(loaderData.user.mobile).then((res) => {
          console.log(res)
          setData(res)
        })
      })
    }
  }

  useEffect(() => {
    document.querySelector('header span').innerText = title

    getPassageList(loaderData.user.mobile).then((res) => {
      console.log(res)
      setData(res)
    })
  }, [])

  return (
    <section className={styles.section}>
      <div className={`__frame`} data-width={`xlarge`}>
        <div className="alert alert--danger">حداکثر حجم فایل ارسال شده بایستی 5 مگابایت و فرمت فایل ارسالی بایستی فایل الکترونیکی (PDF) باشد.</div>

        <div className="alert alert--warning">
          بعد ثبت درخواست
          <b> فرم نام گذاری معابر </b>
          را دانلود کرده و امضاهای مورد نیاز را اخذ فرمایید و در نهایت به سیستم از قسمت
          <b> پیوست فرم نام گذاری </b>
          آپلود نمائید.
        </div>

        <div className="alert alert--dark">تا زمانی که وضعیت درخواست "ثبت شده" می باشد، امکان ویرایش فایل های ارسالی می باشد.</div>

        <div className="alert alert--primary">در صورت نیاز به ویرایش، درخواست مورد نظر پاک کرده و یک درخواست جدید ثبت نمایید. حذف درخواست در صورتی امکان پذیر خواهد بود که وضعیت درخواست در حالت ثبت شده باشد.</div>

        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شناسه پیگیری</th>
                <th>وضعیت</th>
                <th>نام های پیشنهادی</th>
                <th>دانلود فرم نام گذاری معابر</th>
                <th>پیوست فرم نام گذاری</th>
                <th>پیوست سایر </th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((item, i) => {
                  return (
                    <tr key={i} style={{ backgroundColor: i === 0 ? 'var(--blue-050)' : null }}>
                      <td>{++i}</td>
                      <td>{item.id}</td>
                      <td>{determineStatus(item.status)}</td>
                      <td>{typeof JSON.parse(item.suggestion_names) === 'object' ? JSON.parse(item.suggestion_names).join(' | ') : ''}</td>
                      <td>
                        <Link to={`/passage/print?requestId=${item.id}`}>مشاهده و دانلود</Link>
                      </td>
                      <td>
                        {item.main_attachment !== null ? (
                          <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}doc/${item.main_attachment}`} download={true}>
                            فایل شما با موفقیت ارسال گردیده است
                            <br />
                            دانلود فایل ارسالی
                          </a>
                        ) : (
                          <>
                            <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                          </>
                        )}
                        {item.status === '0' && (
                          <details>
                            <summary>جهت ارسال فایل کلیک کنید</summary>
                            <div className={styles.formGroup}>
                              <input type={'file'} accept="application/pdf" name={'mainAttachment'} onChange={(e) => handleUpdate(e, item.id, 'main_attachment')} />
                            </div>
                          </details>
                        )}
                      </td>
                      <td>
                        {item.other_attachment !== null ? (
                          <a target="_blank" className={`${styles.successAlert}`} href={`${process.env.REACT_APP_UPLOAD}doc/${item.other_attachment}`} download={true}>
                            دانلود فایل ارسال شده
                          </a>
                        ) : (
                          <>
                            <span className={styles.warningAlert}>هنوز فایلی ارسال نشده است.</span>
                          </>
                        )}
                        {item.status === '0' && (
                          <details>
                            <summary>جهت ارسال فایل کلیک کنید</summary>
                            <div className={styles.formGroup}>
                              <input type={'file'} accept="image/jpeg,image/jpg,image/gif,image/png,application/pdf,image/x-eps" name={'otherAttachment'} onChange={(e) => handleUpdate(e, item.id, 'other_attachment')} />
                            </div>
                          </details>
                        )}
                      </td>
                      <td>
                        {item.status === '0' && (
                          <>
                            <button onClick={() => navigate('/passage/edit/' + item.id)}>ویرایش</button>
                            |
                            <button onClick={() => handleDelete(item.id)}>حذف</button>
                          </>
                        )}
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>

        <div className="text-center" style={{ textAlign: 'center', marginTop: '1rem' }}>
          <button className="button" onClick={() => navigate(`../`)}>
            بازگشت به صفحه نام گذاری معابر
          </button>
        </div>
      </div>
    </section>
  )
}
